// The gallery API rate-limits (120/min) per connection, and Node >= 19 reuses
// sockets by default, so a reused socket hits 429 under normal traffic. Open a
// new connection per request, as Node 18 did. Server-only: the typeof check lets
// Next drop http/https from the browser bundle (the client uses XHR anyway).
module.exports =
  typeof window === "undefined"
    ? {
        httpAgent: new (require("http").Agent)({ keepAlive: false }),
        httpsAgent: new (require("https").Agent)({ keepAlive: false }),
      }
    : {}
